import { useState } from "react";
import { Button, Checkbox, Label, Modal, Switch } from "@heroui/react";

import { PickupDayPatch, PickupTime } from "@/features/pickup-schedule/type.ts";
import { useBulkUpdatePickupDays } from "@/features/pickup-schedule/use-pickup-schedule.ts";
import { TimesEditor } from "@/features/pickup-schedule/ui/times-editor.tsx";

const DEFAULT_TIMES: PickupTime[] = [
  { value: "09:00", displayTime: "09:00–12:00" },
  { value: "12:00", displayTime: "12:00–17:00" },
];

// Массовое изменение выбранных дат: применяет выбранные поля ко всем датам.
export function BulkEditModal({
  dates,
  onDone,
}: {
  dates: string[];
  onDone: () => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const [applyActive, setApplyActive] = useState(false);
  const [active, setActive] = useState(true);

  const [applyTimes, setApplyTimes] = useState(false);
  const [times, setTimes] = useState<PickupTime[]>(DEFAULT_TIMES);

  const { mutateAsync, isPending } = useBulkUpdatePickupDays();

  const save = () => {
    const patch: PickupDayPatch = {};
    if (applyActive) patch.active = active;
    if (applyTimes) {
      patch.times = times
        .map((t) => ({ value: t.value.trim(), displayTime: t.displayTime.trim() }))
        .filter((t) => t.value && t.displayTime);
    }

    if (Object.keys(patch).length === 0) {
      setIsOpen(false);
      return;
    }

    mutateAsync({ dates, patch }).then(() => {
      setIsOpen(false);
      onDone();
    });
  };

  return (
    <div>
      <Button
        variant="primary"
        isDisabled={dates.length === 0}
        onPress={() => setIsOpen(true)}
      >
        Изменить выбранные ({dates.length})
      </Button>

      <Modal isOpen={isOpen} onOpenChange={setIsOpen}>
        <Modal.Backdrop isDismissable>
          <Modal.Container placement="center">
            <Modal.Dialog>
              <Modal.Header>
                <Modal.Heading>
                  Массовое изменение ({dates.length} дат)
                </Modal.Heading>
              </Modal.Header>

              <Modal.Body>
                <div className="flex flex-col gap-2">
                  <Checkbox isSelected={applyActive} onChange={setApplyActive}>
                    <Checkbox.Control>
                      <Checkbox.Indicator />
                    </Checkbox.Control>
                    <Checkbox.Content>Изменить активность</Checkbox.Content>
                  </Checkbox>

                  {applyActive && (
                    <Switch isSelected={active} onChange={setActive}>
                      <Switch.Control>
                        <Switch.Thumb />
                      </Switch.Control>
                      <Switch.Content>
                        <Label>{active ? "Активны" : "Неактивны"}</Label>
                      </Switch.Content>
                    </Switch>
                  )}
                </div>

                <div className="flex flex-col gap-2">
                  <Checkbox isSelected={applyTimes} onChange={setApplyTimes}>
                    <Checkbox.Control>
                      <Checkbox.Indicator />
                    </Checkbox.Control>
                    <Checkbox.Content>Изменить времена</Checkbox.Content>
                  </Checkbox>

                  {applyTimes && <TimesEditor times={times} onChange={setTimes} />}
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="danger-soft" onPress={() => setIsOpen(false)}>
                  Отмена
                </Button>

                <Button isPending={isPending} variant="primary" onPress={save}>
                  Применить
                </Button>
              </Modal.Footer>
            </Modal.Dialog>
          </Modal.Container>
        </Modal.Backdrop>
      </Modal>
    </div>
  );
}
